// extracted by mini-css-extract-plugin
export default {"modal":"StoreModal_modal__Vm0Um","wrapper":"StoreModal_wrapper__MBTQl","dialog":"StoreModal_dialog__DlX4w","close":"StoreModal_close__Xpyn4","content":"StoreModal_content__uUxBy"};